//Copyright © Yuxi Qin - Check me out at yuxiqin.ca
import React from 'react';

import './Splash.css';
import TextCarousel from './parts/TextCarousel'
import Socials from './parts/Socials'
import Resume from './parts/Resume'

function Splash() {
    return (
        <section id="home" className="splash-intro">
            <div className="row">
                <div className="col col-sm pfp-holder">
                    <div className="pfp"/>
                </div>
                <div className="col col-md profile-descrip">
                    <TextCarousel/>

                    <p className="name profile-item">Yuxi Qin</p>
                    <p className="blurb profile-item">A versatile Computer Engineering student at McMaster University who thrives in unfamiliar environments, pushing boundaries to build something new. Seeking roles to apply extensive knowledge of electrical systems and sensor integration, with a passion for vehicular and robotics development.</p>
                </div>
            </div>

            <div className="row">
                <div className="col col-sm resume-btn-holder">
                    <Resume text="resume" link="https://drive.google.com/file/d/10cBVurJPlTGENNGRwoRunNW5AKLN866L" class="resume-btn" />
                </div>
                <div className="col col-md socials-holder">
                    <Socials />
                </div>
            </div>
        </section>
    )
}

export default Splash;
